<script lang="ts">
    import { onMount } from 'svelte';
    import PageHeader from '../components/PageHeader.svelte';
    import { storeDeliverablesRealisations } from "../scripts/deliverable";
    import Tile from '../components/Tile.svelte';
    import { storeLanguage, lang_fr } from "../scripts/store";

    onMount(async () => {
        window.scrollTo(0,0);
	});

</script>
    
<style lang="scss">

    .realisations {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
        }
        &__title {
            margin: 50px 0 50px 0;
            align-self: flex-start;
        }
        &__tiles {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 32px 0 32px;
            width: 100%;
        }
        &__tile {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            flex-wrap: wrap;
            align-items: center;
            margin: 0 0 60px 0;
            &__mobile {
                &__a {
                    text-decoration: none;
                    color: $color_orange;
                }
            }
            &__desktop {
                display: none;
            }
        }
    }

    @include large {
        .realisations {
            &__tiles {
                display: grid;
                grid-template-columns: 30% 30% 30%;
                align-items: flex-start;
                margin: 0 0 60px 0;
            }
            &__tile {
                cursor: pointer;
                &__mobile {
                    display: none;
                }
                &__desktop {
                    display: flex;
                    height: 100%;
                    &__a {
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                }
            }
        }
    }

</style>

<div class="realisations">
    {#if ($storeLanguage == $lang_fr)}
    <PageHeader props="Livrables réalisations"/>
    {:else}
    <PageHeader props="Deliverables achievements"/>
    {/if}
    <div class="bloc realisations__bloc">
        <div class="realisations__title font__h3">
            {#if ($storeLanguage == $lang_fr)}
            Retrouvez ci-dessous l’ensemble des réalisations du collectif
            {:else}
            Find below all the achievements of the collective
            {/if}
        </div>
        <div class="realisations__tiles">
            {#each $storeDeliverablesRealisations as deliverableRealisation, i}
            <div class="realisations__tile realisations__tile__mobile">
                {#if ($storeLanguage == $lang_fr)}
                <Tile props={{icon: "../assets/images/worksites/worksite"+i+".png", title: deliverableRealisation.title_fr, text: deliverableRealisation.subtitle_fr}}/>
                <a class="realisations__tile__mobile__a" href="../assets/deliverables/realisations/{deliverableRealisation.id}_{deliverableRealisation.file_deliverable}" target="_blank">
                    &darr;&nbsp;Télécharger le livrable
                </a>
                {:else}
                <Tile props={{icon: "../assets/images/worksites/worksite"+i+".png", title: deliverableRealisation.title_en, text: deliverableRealisation.subtitle_en}}/>
                <a class="realisations__tile__mobile__a" href="../assets/deliverables/realisations/{deliverableRealisation.id}_{deliverableRealisation.file_deliverable}" target="_blank">
                    &darr;&nbsp;Download the deliverable
                </a>
                {/if}
            </div>
            <div class="realisations__tile realisations__tile__desktop">
                {#if ($storeLanguage == $lang_fr)}
                <a class="realisations__tile__desktop__a" href="../assets/deliverables/realisations/{deliverableRealisation.id}_{deliverableRealisation.file_deliverable}" target="_blank" title="télécharger le livrable">
                    <Tile props={{icon: "../assets/images/worksites/worksite"+i+".png", title: deliverableRealisation.title_fr, text: deliverableRealisation.subtitle_fr}}/>
                </a>
                {:else}
                <a class="realisations__tile__desktop__a" href="../assets/deliverables/realisations/{deliverableRealisation.id}_{deliverableRealisation.file_deliverable}" target="_blank" title="Download the deliverable">
                    <Tile props={{icon: "../assets/images/worksites/worksite"+i+".png", title: deliverableRealisation.title_en, text: deliverableRealisation.subtitle_en}}/>
                </a>
                {/if}
            </div>
            {/each}
        </div>    
    </div>
</div>
